import { EllipsisVertical, HelpCircle } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { useFeatureFlag } from "../../../../hooks/useFeatureFlag";
import { useOpenUrl } from "../../../../hooks/useOpenUrl";
import { useCallContext } from "../../CallContext";
import { CallDoneDialog } from "../../CallDoneDialog";
import { CallModeMenu } from "../../CallModeMenu";
import { CallStatus } from "../../CallStatus";
import { ToggleProcessScript } from "./CallFooterMenu/ToggleProcessScript";
import { ToggleTestingMode } from "./CallFooterMenu/ToggleTestingMode";

export const CallFooter = () => {
  const {
    roomBot,
    partyServerConnectionStatus,
    handleRequestBotInfo,
    processScript,
    handleToggleProcessScript,
  } = useCallContext();

  const canTest = useFeatureFlag("testing-mode");

  const openUrl = useOpenUrl();

  const status = roomBot?.status_changes?.[
    roomBot.status_changes.length - 1
  ] ?? { code: "starting_up" };

  return (
    <div className="flex items-center justify-between border-t border-gray-300 p-2">
      <div className="flex flex-row space-x-4">
        <CallStatus
          status={status?.code}
          handleRequestBotInfo={handleRequestBotInfo}
          partyServerConnectionStatus={partyServerConnectionStatus}
        />
      </div>
      <div className="flex justify-center">
        <CallModeMenu />
      </div>
      <div className="flex flex-row space-x-2">
        <div>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button size="sm" variant="ghost">
                <EllipsisVertical size={16} />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              {/* <DropdownMenuItem>Latency: {messageLatency} ms</DropdownMenuItem> */}
              {canTest && <ToggleTestingMode />}
              <ToggleProcessScript
                processScript={processScript}
                handleToggleProcessScript={handleToggleProcessScript}
              />
              <DropdownMenuItem
                onClick={() => openUrl("https://intercom.help/frontier-ai/en")}
              >
                <HelpCircle size={12} className="mr-2" /> Help & support
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
        <div>
          <CallDoneDialog />
        </div>
      </div>
    </div>
  );
};
